import { z } from "zod";
import { defineEvent } from "./_define";
import { baseEnvelopeSchema } from "./_envelope";

export const CARE_PROFILE_COMPLETED_VALUES = {
  ADULT: "adult",
  CHILD: "child",
  UNKNOWN: "unknown",
} as const;
export type CareProfileCompletedValue =
  (typeof CARE_PROFILE_COMPLETED_VALUES)[keyof typeof CARE_PROFILE_COMPLETED_VALUES];

const profileEnvelope = baseEnvelopeSchema.passthrough();

export const profileSubmitted = defineEvent({
  eventName: "profile_submitted",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: profileEnvelope,
});

export const profileCancelled = defineEvent({
  eventName: "profile_cancelled",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: profileEnvelope,
});

export const careProfileCompleted = defineEvent({
  eventName: "care_profile_completed",
  eventVersion: 1,
  valueSchema: z
    .enum([
      CARE_PROFILE_COMPLETED_VALUES.ADULT,
      CARE_PROFILE_COMPLETED_VALUES.CHILD,
      CARE_PROFILE_COMPLETED_VALUES.UNKNOWN,
    ])
    .or(z.string())
    .optional(),
  metadataSchema: profileEnvelope,
});

export const accountCreated = defineEvent({
  eventName: "account_created",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: profileEnvelope,
});

export const accountExistingReturn = defineEvent({
  eventName: "account_existing_return",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: profileEnvelope,
});

export const hipaaConsentAccepted = defineEvent({
  eventName: "hipaa_consent_accepted",
  eventVersion: 1,
  valueSchema: z.union([z.string(), z.number()]).optional(),
  metadataSchema: profileEnvelope,
});
